import { useAuth } from "../hooks/useAuth";
import GroupCockpitDashboard from "../pages/groupCockpit/GroupCockpitDashboard";
import SchoolCockpitDashboard from "../pages/schoolCockpit/SchoolCockpitDashboard";

const UserDashboardResolver = () => {
  const { user } = useAuth();
  const roleId = Number(user?.role?.id);
  // console.log(roleId, "roleIdroleId");

  switch (roleId) {
    case 2:
      return <GroupCockpitDashboard />;
    case 3:
      return <SchoolCockpitDashboard />;
    case 4:
      return <SchoolCockpitDashboard />;
    case 5:
      return <SchoolCockpitDashboard />;
    case 6:
      return <SchoolCockpitDashboard />;
    default:
      return <SchoolCockpitDashboard />;
  }
};

export default UserDashboardResolver;
